import {Stat} from './stat';
import {Offer} from '../offer';
import {CustomPayout} from '../custom-payout';

export class TopOffer extends Stat {
  offer: Offer | null = null;
  customPayout: CustomPayout | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    if (input.customPayout) {
      this.customPayout = new CustomPayout().deserialize(input.customPayout);
    }

    return this;
  }

  override toString(): string {
    return this.offer?.name ?? '';
  }
}
